import { defineComponent as f, toRefs as g, createElementBlock as o, createCommentVNode as v, openBlock as r, unref as t, Fragment as b, renderList as p, mergeProps as x, withModifiers as _, renderSlot as h } from "vue";
import { d as I, e as i, I as M, _ as k } from "./main-CMkgZyMy.mjs";
const y = ["aria-label", "aria-selected", "onMouseover", "onMousedown"], A = /* @__PURE__ */ f({
  __name: "SearchListbox",
  props: {
    suggestions: {
      type: Array,
      required: !0
    }
  },
  emits: ["item-activate"],
  setup(s, {
    emit: l
  }) {
    const {
      listboxActiveIndex: u
    } = g(I), c = l;
    return (d, n) => s.suggestions.length > 0 ? (r(), o("ul", {
      key: 0,
      role: "listbox",
      class: "search-listbox",
      onMouseleave: n[0] || (n[0] = (e) => t(i)(t(M), 0))
    }, [(r(!0), o(b, null, p(s.suggestions, (e, a) => (r(), o("li", x({
      key: e.key,
      "aria-label": e.term,
      role: "option",
      class: "search-listbox__list-item",
      "aria-selected": a === t(u),
      ref_for: !0
    }, e.listElementAttributes, {
      onMouseover: (m) => t(i)(a, s.suggestions.length),
      onMousedown: _((m) => c("item-activate", e), ["left"])
    }), [h(d.$slots, "default", {
      item: e
    }, void 0, !0)], 16, y))), 128))], 32)) : v("", !0);
  }
}), $ = /* @__PURE__ */ k(A, [["__scopeId", "data-v-20d3a1e9"]]);
export {
  $ as S
};
